import Vue from 'vue'
import Vuex from 'vuex'

import registration from './registration'
import login from './login'
import logout from './logout'

import addNewAddress from './addNewAddress'
import userAccounts from './userAccounts'
import userAccountsInfo from './userAccountsInfo'
import userPayPeriodsData from './userPayPeriodsData'
import changeUserInfo from './changeUserInfo'
import deleteLs from './deleteLs'
import deleteProfile from './deleteProfile'
import FeedBackForm from './FeedBackForm'
import confirmUserData from './confirmUserData'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locale: 'uk_UA',
    lang: 'uk',
    columns: ['Період розрахунку', 'Залишок на початок місяця («+» - борг, «-» - переплата)', 'Нараховано','Перерахунок','Абонплата','Сплачено','Монетизація', 'Залишок на кінець місяця («+» - борг, «-» - переплата)'],
    dates: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
    no_data_text: 'Спочатку визначте діапазон дат'
  },
  mutations: {
    localize(state, payload){
      const langs = {
        'ru_RU': 'ru',
        'uk_UA': 'uk',
      }
      state.locale = payload
      state.lang = langs[payload] || 'uk'
    },
    tableHeadersLang(state, payload){
      state.columns = payload
    },
    noDataCommit(state, payload){
      state.no_data_text = payload
    },
    tableDatesLang(state, payload){
      state.dates = payload
    }
  },
  actions: {
  },
  getters: {
    locale: s => s.locale,
    lang: s => s.lang,
    columns: s => s.columns,
    no_data_text: s => s.no_data_text,
    dates: s => s.dates,
  },
  modules: {
    registration, 
    login, 
    logout, 
    addNewAddress, 
    userAccounts, 
    userAccountsInfo, 
    userPayPeriodsData, 
    changeUserInfo, 
    deleteLs, 
    deleteProfile, 
    FeedBackForm,
    confirmUserData,
  }
})
